import './style.css'
export const GuestBaseFooter = (props = {}) => {
  const { contents } = props
  return (
    <div className="text-center text-dark bg-white py-3 guest-base-footer">
      <b>{contents?.companyName}</b> <br />
      <span>{contents?.address}</span>
      <br />
      {contents?.hotline && (
        <span>
          Hotline:{' '}
          <span>
            <a style={{ color: 'red' }} href={`tel: ${contents?.hotline}`}>
              {contents?.hotline}
            </a>
          </span>
        </span>
      )}
    </div>
  )
}
